import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import CategoryMenu from "./CategoryMenu";
import GroupMenu from "./GroupMenu";
import DndList from "components/DndAdvance";
import DndListAdvanced from "components/DndAdvance";
import { Button, TextField } from "@mui/material";
import {
  useAddCategoryMutation,
  useClearCacheMutation,
  useModifyProductsOrderMutation,
} from "api/apiSlice";
import SmallDialog from "components/SmallDialog";
import Toast from "components/Toast";
import { current } from "@reduxjs/toolkit";

function Row({
  row,
  cat_index,
  setCategoriesOrder,
  cats,
  handleMoveProduct,
  updateTree,
}) {
  const [open, setOpen] = useState(false);
  const [rowx, setrowx] = useState(row);
  const [rowItems, setrowItems] = useState([]);

  useEffect(() => {
    if (rowx) {
      setrowItems(
        rowx.products.map((product, index) => {
          return {
            name: product.name,
            featured: product.featured,
            item: (
              <Box
                key={product.name}
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "13px",
                  gap: "20px",
                  borderBottom: "1px solid rgb(160, 160, 160)",
                }}
              >
                <Box
                  sx={{
                    width: "200px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: "4px",
                  }}
                >
                  <Typography>{product.name}</Typography>
                  <Typography sx={{ fontSize: "12px", color: "#fecd27" }}>
                    {product.hasOwnProperty("display_name")
                      ? product.display_name
                      : product.name}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: "100px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: "4px",
                  }}
                >
                  <Typography sx={{ fontSize: "12px" }}>
                    {product._id}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: "100px",
                  }}
                >
                  {product.production ? (
                    <Typography sx={{ color: "#6a9c55" }}>released</Typography>
                  ) : (
                    <Typography sx={{ color: "#fc0000" }}>
                      not released
                    </Typography>
                  )}
                </Box>
                <Box>
                  {product.featured ? (
                    <Typography sx={{ color: "#6a9c55" }}>yes</Typography>
                  ) : (
                    <Typography sx={{ color: "#fc0000" }}>no</Typography>
                  )}
                </Box>
                <Box>
                  {product.teaser ? (
                    <Typography sx={{ color: "#6a9c55" }}>yes</Typography>
                  ) : (
                    <Typography sx={{ color: "#fc0000" }}>no</Typography>
                  )}
                </Box>

                <Box>
                  <GroupMenu
                    group={product}
                    index={index}
                    cat_index={cat_index}
                    update={handleUpdateProduct}
                    add={handleAddProduct}
                    cats={cats}
                    handleMoveProduct={(product, index, old_cat) =>
                      handleMoveProduct(product, index, old_cat)
                    }
                  />
                </Box>
              </Box>
            ),
            id: index + 1,
          };
        })
      );
    }
  }, [rowx]);

  useEffect(() => {
    row && setrowx(row);
  }, [row]);

  // useEffect(() => {
  //   setRows((current) =>
  //     current.map((r, index) => {
  //       if (index === cat_index) {
  //         r.products = rowItems;
  //       }
  //     })
  //   );
  //   // console.log(rowItems);
  // }, [rowItems]);

  const handleNameUpdate = (value) => {
    let temp = { ...rowx };
    temp["name"] = value;
    setrowx(temp);
  };

  const handleDeleteCategory = () => {
    updateTree(rowx.name);
  };

  const handleAddProduct = (product) => {
    let temp = { ...rowx };
    temp["productsCount"] = temp["productsCount"] + 1;
    temp.products.push(product);
    setrowx(temp);
  };

  const handleUpdateProduct = (key, value, index) => {
    let tempRow = { ...rowx };
    let tempProducts = [...rowx.products];
    if (key === "delete") {
      tempProducts.splice(index, 1);
      tempRow.products = tempProducts;
      tempRow["productsCount"] = tempRow["productsCount"] - 1;
      setrowx(tempRow);
    } else {
      tempProducts[index][key] = value;
      tempRow.products = tempProducts;
      setrowx(tempRow);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "13px",
          marginLeft: "20px",
          gap: "20px",
          borderBottom: "1px solid rgb(160, 160, 160)",
        }}
      >
        <Box
          sx={{
            width: "840px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            gap: "20px",
          }}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            // onClick={() => console.log("open")}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          <Box
            sx={{
              width: "540px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <Typography>{rowx.name}</Typography>
          </Box>
        </Box>

        <Box>
          <Typography>{rowx.productsCount}</Typography>
        </Box>
        <Box align="right">
          <CategoryMenu
            name={rowx.name}
            updateName={handleNameUpdate}
            addProduct={handleAddProduct}
            deleteCategory={handleDeleteCategory}
          />
        </Box>
      </Box>
      <TableRow sx={{ width: "1000px" }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Products{" "}
                <p style={{ color: "#ff6000", fontSize: "13px" }}>
                  {rowx.name}
                </p>
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "13px",
                  marginLeft: "20px",
                  gap: "20px",
                  borderBottom: "1px solid rgb(160, 160, 160)",
                }}
              >
                <Box
                  sx={{
                    width: "240px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: "20px",
                  }}
                >
                  <Typography>NAME</Typography>
                </Box>
                <Box
                  sx={{
                    width: "140px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: "20px",
                  }}
                >
                  <Typography>ID</Typography>
                </Box>
                <Box
                  sx={{
                    width: "110px",
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "center",
                    gap: "20px",
                    textAlign: "center",
                  }}
                >
                  <Typography>STATUS</Typography>
                </Box>
                <Box>
                  <Typography>FEATURED</Typography>
                </Box>
                <Box>
                  <Typography>TEASER</Typography>
                </Box>
                <Box>
                  <Typography>ACTIONS</Typography>
                </Box>
              </Box>
              <DndListAdvanced
                items={rowItems}
                setItems={setrowItems}
                setCategoriesOrder={setCategoriesOrder}
                product={true}
                index={rowx.name}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default function CategoryManagerTable({ rows, updateTree, order }) {
  const [addCategory] = useAddCategoryMutation();
  const [saveOrder] = useModifyProductsOrderMutation();
  const [clearCache] = useClearCacheMutation();

  const [rowsx, setrowsx] = useState(rows);
  const [rowsItems, setrowsItems] = useState([]);
  const [catsNames, setcatsNames] = useState();
  const [productsOrder, setProductsOrder] = useState([]);
  const [categoriesOrder, setCategoriesOrder] = useState([]);

  const [addCategoryOpen, setaddCategoryOpen] = useState(false);
  const [addCategoryData, setaddCategoryData] = useState(false);
  const [categoryName, setcategoryName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataReady, setdataReady] = useState(false);
  const open = Boolean(anchorEl);

  const [alert, setAlert] = useState({
    show: false,
    severity: "success",
    msg: "",
  });

  useEffect(() => {
    console.log("rerender");
    if (rowsx) {
      console.log(rowsx);
      setrowsItems(
        rowsx.map((row, index) => {
          return {
            name: row.name,
            item: (
              <Row
                key={row.name}
                row={row}
                cat_index={index + 1}
                setCategoriesOrder={setCategoriesOrder}
                cats={catsNames}
                handleMoveProduct={handleMoveProduct}
                updateTree={handleUpdateTree}
              />
            ),
            products: row.products,
            id: index + 1,
          };
        })
      );
      setCategoriesOrder(
        rowsx.map((row, index) => {
          return {
            name: row.name,
            item: (
              <Row
                key={row.name}
                row={row}
                cat_index={index + 1}
                setCategoriesOrder={setCategoriesOrder}
                cats={catsNames}
                handleMoveProduct={handleMoveProduct}
                updateTree={handleUpdateTree}
              />
            ),
            products: row.products,
            id: index + 1,
          };
        })
      );
    }
  }, [rowsx]);

  useEffect(() => {
    if (rows) {
      console.log(order);
      setrowsx(rows);
      setcatsNames(rows.map((row) => row.name));
    }
  }, [rows]);

  const handleMoveProduct = (product, index, old_cat) => {
    console.log(
      `moving ${product.name} to category index ${index} from ${old_cat}`
    );
    let temp = [...rows];
    var temp2 = temp.map((category) => {
      if (category.name === old_cat) {
        console.log("removing from old category", old_cat);
        category.products = category.products.filter(
          (prod) => prod.name !== product.name
        );
      }
      if (product.parent === category.name) {
        console.log("adding to new category", product.parent);
        category["productsCount"] = category["productsCount"] + 1;
        category.products.push(product);
      }

      return category;
    });
    // temp[index ]['productsCount'] = temp[index - 1]['productsCount'] + 1;
    // temp[index - 1].products.push(product);
    console.log(temp2);
    setrowsx(temp2);
    setAlert({
      show: true,
      severity: "success",
      msg: "Category changed",
    });
  };

  const handleSaveOrder = async () => {
    console.log("CATEGORIES ORDER", categoriesOrder);
    const o = {};
    categoriesOrder.map((cat) => {
      o[cat.name] = cat.products.map((product) => product._id);
    });
    // console.log(o);
    const res = await saveOrder({ order: o }).unwrap();
    setAlert({
      show: true,
      severity: "success",
      msg: "Order updated.",
    });
  };

  useEffect(() => {
    if (addCategoryData) {
      setAnchorEl(null);
      handleAddCategory();
    }
  }, [addCategoryData]);

  const handleAddCategory = async () => {
    const result = await addCategory(categoryName).unwrap();
    console.log(result);
    if (result.success) {
      setrowsItems((current) => [
        ...current,
        {
          name: categoryName,
          item: (
            <Row
              key={categoryName}
              row={{ products: [], name: categoryName, productsCount: 0 }}
              cat_index={current.length + 1}
              setCategoriesOrder={setCategoriesOrder}
              cats={catsNames}
              handleMoveProduct={handleMoveProduct}
              updateTree={handleUpdateTree}
            />
          ),
          products: [],
          id: current.length + 1,
        },
      ]);

      setAlert({
        show: true,
        severity: "success",
        msg: result.msg,
      });
    } else {
      setAlert({
        show: true,
        severity: "error",
        msg: result.msg,
      });
    }
    setaddCategoryData(false);
  };

  const handleUpdateTree = (name) => {
    updateTree(
      catsNames.filter((cat) => cat !== name),
      rowsx.map((row) => row.products)
    );
  };

  const handlClearCache = async () => {
    const res = await clearCache().unwrap();
    if (res.success) {
      setAlert({
        show: true,
        severity: "success",
        msg: "Cache cleared",
      });
    } else {
      setAlert({
        show: true,
        severity: "error",
        msg: "Something went wrong",
      });
    }
  };

  return (
    <>
      <Toast alert={alert} setAlert={setAlert}></Toast>
      <SmallDialog
        title="Create category"
        content=""
        open={addCategoryOpen}
        setOpen={setaddCategoryOpen}
        setData={setaddCategoryData}
        cancelButton="Cancel"
        confirmButton="Save"
        blocked={false}
      >
        <TextField
          margin="normal"
          id="promptName"
          label="name"
          name="name"
          value={categoryName}
          onChange={(e) => setcategoryName(e.target.value)}
          className="ring-0"
          sx={{ width: "300px" }}
          size="small"
          onKeyDown={(e) => e.stopPropagation()}
        />
      </SmallDialog>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          gap: "20px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            gap: "20px",
          }}
        >
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#BBFF00",
              color: "#000",
              "&:hover": {
                backgroundColor: "#A5E000",
              },
              fontWeight: 700,
            }}
            onClick={() => setaddCategoryOpen(true)}
          >
            ADD CATEGORY
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#BBFF00",
              color: "#000",
              "&:hover": {
                backgroundColor: "#A5E000",
              },
              fontWeight: 700,
            }}
            onClick={handleSaveOrder}
          >
            Save
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#F35B04",
              color: "#000",
              "&:hover": {
                backgroundColor: "#C94C03",
              },
              fontWeight: 700,
            }}
            onClick={handlClearCache}
          >
            CLEAR CACHE
          </Button>
        </Box>

        <DndListAdvanced
          items={rowsItems}
          setItems={setrowsItems}
          setCategoriesOrder={setCategoriesOrder}
          product={false}
          index={0}
        />
      </Box>
    </>
  );
}
